exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.explain[data-v-d764b1dc] {\n  height: 2rem;\n  background: #ffecf3;\n  color: #FC5D7B;\n}\n.explain .markImg[data-v-d764b1dc] {\n  display: inline-block;\n  width: 0.55rem;\n  height: 0.55rem;\n  margin-right: 0.1rem;\n}\n.explain .markImg img[data-v-d764b1dc] {\n  width: 100%;\n  margin-top: -0.1rem;\n}\n.explain .pinkImg[data-v-d764b1dc] {\n  display: inline-block;\n  width: 0.3rem;\n  height: 0.5rem;\n}\n.explain .pinkImg img[data-v-d764b1dc] {\n  width: 100%;\n  margin-top: -0.3rem;\n}", ""]);

// exports
